
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { of } from 'rxjs';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResult } from 'src/app/models/base-http-response';
import { ResultadoAutenticacao } from 'src/app/models/employee.model';
import { ApiConfig } from 'src/app/configs';
import { User } from 'src/app/global-functions';
const PROTOCOL = 'http';
const PORT = 3500;


@Injectable()
export class AuthService {
  auth_token: string = '';

  constructor(private http: HttpClient) {
    this.setToken(User.getTokenLocalStorage());
  }

  authenticate(username: string, password: string): Observable<ResultadoAutenticacao> {
    var body = { username: username, password: password };
    return this.http.post<ResultadoAutenticacao>(ApiConfig.getUrlBase() + 'Auth/Autentica', body, ApiConfig.getOptions()).pipe(res => res);
  }

  setToken(token: string) {
    this.auth_token = token;
  }

  logout() {
    this.clear();
  }

  get authenticated(): boolean {
    return (this.auth_token !== '' && this.auth_token !== undefined);
  }

  clear() {
    User.removeTokenLocalStorage();
    this.setToken('');
  }
}
